import styled from 'styled-components'

const IconWrapper = styled.div`
  opacity: 0.3;
  cursor: pointer;
  transition: opacity 0.3s;
  
  &:hover {
    opacity: 1;
  }
`;

export default IconWrapper
